import React from "react";
import MenuGroup from "../../menu-group";
import CustomLink from "@/bit/components/next13.components.custom-link";
import Text from "@/bit/components/next13.components.text";

const DefaultMenu = (props) => {
  if (!props["items"]) {
    return null;
  }
  const items = Object.values(props["items"]);
  const { location } = props;
  let i = 0;
  return (
    <>
      {items.map((item) => {
        const link = item.link ? item.link : "#";
        const text = item.text;

        var selectedItem = item.selected;

        if (!item.sections) {
          return (
            <CustomLink
              href={link}
              title={text}
              ariaLabel={text}
              key={`item-${i++}`}
              taggingInfo={{
                componentName: "header",
                componentContent: text,
                componentVariation: location,
                componentPerso: "",
                componentProduct: "",
              }}
              cyData={`Header item ${text}`}
            >
              <div className={`menu-item ${selectedItem ? " selected" : ""}`}>
                <Text
                  text={text}
                  fontType="font-regular"
                  size="caption01"
                  color="grey5"
                  display="block"
                />
              </div>
            </CustomLink>
          );
        } else {
          return <MenuGroup key={`item-${i++}`} item={item} />;
        }
      })}
    </>
  );
};
export default DefaultMenu;
